import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  FormControl,
  TextField,
  Typography,
  LinearProgress,
  AppBar,
  Toolbar,
  Card,
  CardContent,
  Grid,
} from '@mui/material';
import { styled } from '@mui/system';
import Selector from '../../components/common/Selector';
import SitemarkIcon from '../../components/common/SitemarkIcon';
import { tiposCompania, monedas, paises } from '../../utils/staticvariables';

const Header = styled(AppBar)({
  backgroundColor: 'transparent',
  boxShadow: 'none',
  borderBottom: '1px solid #e7edf4',
  padding: '12px 40px',
});

const Step1CompanyInfo = ({ form, setForm, onBack,onNext }) => {
  // Campos
  const [companyName, setCompanyName] = useState(form.general?form.general.companyName || '': '');
  const [taxId, setTaxId] = useState(form.general?form.general.taxId || '': '');
  const [phone, setPhone] = useState(form.general?form.general.phone || '': '');
  const [address, setAddress] = useState(form.general?form.general.address || '': '');
  const [currency, setCurrency] = useState(form.general?form.general.currency || '': '');
  const [country, setCountry] = useState(form.general?form.general.country || '': '');
  const [modules, setModules] = useState([

  ]);
  const [companyTypes, setCompanyTypes] = useState(tiposCompania);

  const [companyTypesSelected, setCompanyTypesSelected] = useState(form.general?form.general.companyTypes || []:[]);


  // Errores
  const [errors, setErrors] = useState({});

  // Manejo de errores individuales
  const clearError = (field) => {
    setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const handleNext = () => {
    const newErrors = {};

    if (!companyName.trim()) newErrors.companyName = 'Este campo es obligatorio';
    if (companyTypesSelected.length === 0) newErrors.companyTypesSelected = 'Seleccione al menos una opción';
    if (!taxId.trim()) newErrors.taxId = 'Este campo es obligatorio';
    if (!phone.trim()) newErrors.phone = 'Este campo es obligatorio';
    if (!address.trim()) newErrors.address = 'Este campo es obligatorio';
    if (!currency) newErrors.currency = 'Seleccione una opción';
    if (!country) newErrors.country = 'Seleccione una opción';

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setForm({
        ...form,
        general: {
          companyName,
          companyTypes: companyTypesSelected,
          taxId,
          phone,
          address,
          currency,
          country,
        },
      });
      onNext();
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #4a9b94 0%, #3a7a73 100%)',
        fontFamily: 'Inter, Noto Sans, sans-serif',
      }}
    >
      <Header position="static">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box display="flex" alignItems="center" gap={2}>
            <SitemarkIcon />
            <Typography variant="h6" sx={{ fontWeight: 600, color: 'white' }}>
              Bankivo Assist
            </Typography>
          </Box>
        </Toolbar>
      </Header>

      <Container maxWidth="md" sx={{ py: 5 }}>
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h4" sx={{ fontWeight: 600, color: 'white', mb: 1 }}>
            Configuración Inicial
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
            Paso 1: Información de la empresa
          </Typography>
        </Box>

        <Card sx={{ borderRadius: 2, boxShadow: 4 }}>
          <CardContent sx={{ p: 4 }}>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
                  Nombre de la empresa *
                </Typography>
                <TextField
                  placeholder="Nombre de la empresa"
                  fullWidth
                  value={companyName}
                  onChange={(e) => {
                    setCompanyName(e.target.value);
                    clearError('companyName');
                  }}
                  error={!!errors.companyName}
                  helperText={errors.companyName}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1,
                      backgroundColor: '#F8F9FA',
                    },
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
                  Tipo de financiera *
                </Typography>
                <FormControl fullWidth error={!!errors.companyTypesSelected}>
                  <Selector
                    multiple
                    value={companyTypesSelected}
                    onChange={(e) => {
                      setCompanyTypesSelected(e.target.value);
                      clearError('companyTypesSelected');
                    }}
                    options={companyTypes}
                    placeholder="Seleccione uno o varios tipos de financiera"
                    error={!!errors.companyTypesSelected}
                  />
                  {errors.companyTypesSelected && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                      {errors.companyTypesSelected}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
                  Identificación fiscal *
                </Typography>
                <TextField
                  placeholder="Identificación fiscal"
                  fullWidth
                  value={taxId}
                  onChange={(e) => {
                    setTaxId(e.target.value);
                    clearError('taxId');
                  }}
                  error={!!errors.taxId}
                  helperText={errors.taxId}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1,
                      backgroundColor: '#F8F9FA',
                    },
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
                  Teléfono *
                </Typography>
                <TextField
                  placeholder="Teléfono"
                  fullWidth
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    clearError('phone');
                  }}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1,
                      backgroundColor: '#F8F9FA',
                    },
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
                  Dirección *
                </Typography>
                <TextField
                  placeholder="Dirección"
                  fullWidth
                  value={address}
                  onChange={(e) => {
                    setAddress(e.target.value);
                    clearError('address');
                  }}
                  error={!!errors.address}
                  helperText={errors.address}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1,
                      backgroundColor: '#F8F9FA',
                    },
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
                  País *
                </Typography>
                <FormControl fullWidth error={!!errors.country}>
                  <Selector
                    value={country}
                    onChange={(e) => {
                      setCountry(e.target.value);
                      clearError('country');
                    }}
                    options={paises}
                    placeholder="Seleccione el país"
                    error={!!errors.country}
                  />
                  {errors.country && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                      {errors.country}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
                  Moneda *
                </Typography>
                <FormControl fullWidth error={!!errors.currency}>
                  <Selector
                    value={currency}
                    onChange={(e) => {
                      setCurrency(e.target.value);
                      clearError('currency');
                    }}
                    options={monedas}
                    placeholder="Seleccione la moneda"
                    error={!!errors.currency}
                  />
                  {errors.currency && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                      {errors.currency}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Box mt={4}>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', mb: 1 }}>
            Paso 1 de 3
          </Typography>
          <LinearProgress 
            variant="determinate" 
            value={33} 
            sx={{ 
              bgcolor: 'rgba(255, 255, 255, 0.3)', 
              height: 8, 
              borderRadius: 1,
              '& .MuiLinearProgress-bar': {
                bgcolor: 'white',
              },
            }} 
          />
        </Box>

        <Box display="flex" justifyContent="flex-end" mt={4}>
          <Button
            variant="contained"
            onClick={handleNext}
            sx={{
              fontWeight: 600,
              borderRadius: 1,
              px: 4,
              py: 1.5,
              textTransform: 'none',
              backgroundColor: 'white',
              color: '#18586b',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
              },
            }}
          >
            Siguiente
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Step1CompanyInfo;
